import { BlockchainType } from '@compliance/types/coin'

export type Asset = {
  id: number
  name: string
  symbol: string
  blockchain: BlockchainType
  icon: string | null
}

const baseAssets: Asset[] = [
  {
    id: -1,
    name: 'Bitcoin',
    symbol: 'BTC',
    blockchain: 'BTC',
    icon: null,
  },
  {
    id: -2,
    name: 'Ethereum',
    symbol: 'ETH',
    blockchain: 'ETH',
    icon: null,
  },
]

export default baseAssets
